module.exports = __webpack_public_path__ + "img/social-media-screening.8493d69d.svg";